// src/features/bookings/components/BookingList/BookingTable.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../../../../shared/components/ui/Table';
import { formatNumber, BOOKING_TYPE_LABELS, BOOKING_STATUS_LABELS } from '../../../../shared/utils/formatters';
import styles from './BookingTable.module.css';

// ─── تعريف الأعمدة ───────────────────────────────────────────────
const buildColumns = () => [
  {
    key:      'index',
    label:    '#',
    width:    '50px',
    render:   (_, __, index) => index + 1,
  },
  {
    key:      'client',
    label:    'العميل',
    sortable: true,
    render:   (_, row) => row.client?.name ?? 'غير محدد',
  },
  {
    key:      'booking_type',
    label:    'نوع الحجز',
    sortable: true,
    render:   (val) => BOOKING_TYPE_LABELS[val] ?? val,
  },
  {
    key:      'booking_date',
    label:    'تاريخ الحجز',
    sortable: true,
  },
  {
    key:      'status',
    label:    'الحالة',
    sortable: true,
    render:   (val) => (
      <span className={`${styles.badge} ${styles[val]}`}>
        {BOOKING_STATUS_LABELS[val] ?? val}
      </span>
    ),
  },
  {
    key:      'total_price',
    label:    'الإجمالي',
    sortable: true,
    render:   (val) => formatNumber(val),
  },
  {
    key:      'total_paid',
    label:    'المدفوع',
    sortable: true,
    render:   (val) => formatNumber(val),
  },
  {
    key:      'remaining_amount',
    label:    'المتبقي',
    sortable: true,
    render:   (val) => formatNumber(val),
  },
];

// ─── المكون ──────────────────────────────────────────────────────
const BookingTable = ({ bookings, sortConfig, onSort, loading }) => {
  const navigate = useNavigate();

  // نضيف index لكل صف لأن Table.jsx يحتاجه للـ render
  const dataWithIndex = bookings.map((b, i) => ({ ...b, index: i }));

  const columns = buildColumns();

  return (
    <Table
      columns={columns}
      data={dataWithIndex}
      sortConfig={sortConfig}
      onSort={onSort}
      onRowClick={(row) => navigate(`/booking/${row.id}`)}
      emptyMessage="لا توجد حجوزات تطابق الفلاتر المحددة."
      loading={loading}
    />
  );
};

export default BookingTable;